import React from "react";
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';

export default function NumberFormatPercent(props) {
  const { inputRef, onChange, ...numberFormatProps } = props;
  
  const MAX_VAL = 100;
  const MIN_VAL = 0;
  const withValueLimit = ({ value }) => (value <= MAX_VAL && value>=MIN_VAL) || value==='';

  return (
    <NumberFormat
      {...numberFormatProps}
      getInputRef={inputRef}
      isAllowed = {withValueLimit}
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
      isNumericString
      suffix="%"
      allowNegative={false}   
      decimalScale={2}
    />
  );
}

NumberFormatPercent.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Formatters/NumberFormatPercent.js